module.exports = __webpack_public_path__ + "static/media/010.fc2e9df6.jpg";